module.exports = __webpack_public_path__ + "static/media/pool-live-home-ss.bde57ab7.png";